import { memo } from 'react';
import styles from './styles.module.scss';
import { useGeneratorsByLevel } from '../../store/global-context';
import { GameGenerator } from '../GameGenerator';
import { Generator, UnitType } from '../../types/game-types';
import { GeneratorContextProvider } from '../../store/generator-context';

export const GeneratorsRow = memo(function GeneratorsRow({ level, type }: { level: number; type: UnitType }) {
  const generatorsList = useGeneratorsByLevel(level, type);

  return (
    <div className={`${styles.generatorFrame}}`}>
      <div className={styles.generators}>
        {generatorsList.map((generator: Generator) => (
          <GeneratorContextProvider key={generator.id} value={generator.id}>
            <GameGenerator generator={generator} />
          </GeneratorContextProvider>
        ))}
      </div>
    </div>
  );
});
